import React, {useState, useEffect} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TRUE} from "../../../constants/general-constants";
import {FALSE} from "../../../constants/general-constants";
import {useHistory} from 'react-router-dom';
import {functions} from "../../../constants/common-functions";
import HomeBox from "../components/HomeBox";
import {COLOR_SOCIAL} from "../../../constants/general-constants";
import HomeBoxRAG from "../components/HomeBoxRAG";
import {OMNISCAN_BLUE} from "../../../constants/colors";
import {OMNISCAN_BLUE_RGB} from "../../../constants/colors";

export default function HomeBoxTasks({homeConfig, isMobile}){
	
	const [isLive, setIsLive] = useState(false);
	const history = useHistory();
	const [total, setTotal] = useState(0);
	const [red, setRed] = useState(0);
	const [amber, setAmber] = useState(0);
	const [green, setGreen] = useState(0);
	
	useEffect(() => {
		if(homeConfig){
			setIsLive(homeConfig.isLiveLinkTickets);
			setTotal(homeConfig.ppmTotal);
			setRed(homeConfig.ppmRed);
			setAmber(homeConfig.ppmAmber);
			setGreen(homeConfig.ppmGreen);
		}
	}, [homeConfig]);
	
	
	const thisContainer = {
		display:'flex',
		width:"100%",
		minHeight:"50px"
	};
	
	
	
	const clickFunction = () => {
		
	};
	
	
	return (
		<HomeBox
			isMobile={isMobile}
			isLive={isLive}
			title="Tasks"
			color={OMNISCAN_BLUE}
			colorRgb={OMNISCAN_BLUE}
			clickFunction={clickFunction}
			icon="cogs"
			delay={960}
		>
			<HomeBoxRAG
				title="Tickets & PPMs"
				total={total}
				red={red}
				amber={amber}
				green={green}
			/>
		</HomeBox>
	);
}